import type { UseQueryResult } from "@tanstack/react-query";

import type { AiTrackerReportsBrandOverviewBrandVisibilityMentionShareResponse } from "@similarweb/pro-api-client";

import { apiClient } from "app/modules/api-client";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

export const useBrandOverviewData = (
    params: ILLMWidgetRequestParams,
    options?: { enabled?: boolean },
): UseQueryResult<AiTrackerReportsBrandOverviewBrandVisibilityMentionShareResponse> =>
    useLLMReportQuery<AiTrackerReportsBrandOverviewBrandVisibilityMentionShareResponse, ILLMWidgetRequestParams>(
        "brandOverview",
        apiClient.AiTracker.aiTrackerReportsBrandVisibilityReportBrandVisibilityOverviewList,
        params,
        options,
    );
